import { useEffect } from 'react';
import '../../assets/css/toast.css';

export default function Toast({ message, type = 'success', onClose, duration = 3000 }) {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    return (
        <div className={`toast toast--${type}`}>
            <div className="toast__icon">
                {type === 'success' && <i className="fas fa-check-circle"></i>}
                {type === 'error' && <i className="fas fa-exclamation-circle"></i>}
                {type === 'info' && <i className="fas fa-info-circle"></i>}
                {type === 'warning' && <i className="fas fa-exclamation-triangle"></i>}
            </div>
            <div className="toast__message">{message}</div>
            <button className="toast__close" onClick={onClose}>
                <i className="fas fa-times"></i>
            </button>
        </div>
    );
}
